var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.assetTrayGrouping)?_c('div',{staticClass:"asset-tray-activator",on:{"click":_vm.toggleAssetTray}},[_c('div',{staticClass:"circle"},[_c('icon',{attrs:{"name":"file-folder"}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.showAssetTray ? "Hide" : "View")+" Patient Files")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }